export default (selectEl, optionsObject, label, selectedKey) => {

  while(selectEl.options.length > 0) {
    selectEl.remove(0);
  }

  let options = [];

  if(label) {
    const placeholder = document.createElement('option')
    placeholder.value = ''
    placeholder.text = label

    options.push(placeholder)
  }

  Object.keys(optionsObject).forEach(key => {
    const option = document.createElement('option')
    option.value = key
    option.text = optionsObject[key]
    option.selected = selectedKey === key
    options.push(option)
  });

  options.forEach(option => {
    selectEl.add(option);
  })
}
